type Props = {
	header: string
	base: string
}

export const defaultFonts = (fontFamily: Props) => ({
	xxLarge: {
		light: `300 22px/136% ${fontFamily.header}`,
		base: `400 22px/136% ${fontFamily.header}`,
		medium: `500 22px/136% ${fontFamily.header}`,
		bold: `700 22px/136% ${fontFamily.header}`,
	},
	xLarge: {
		light: `300 18px/144% ${fontFamily.header}`,
		base: `400 18px/144% ${fontFamily.header}`,
		medium: `500 18px/144% ${fontFamily.header}`,
		bold: `700 18px/144% ${fontFamily.header}`,
	},
	large: {
		light: `300 16px/150% ${fontFamily.header}`,
		base: `400 16px/150% ${fontFamily.header}`,
		medium: `500 16px/150% ${fontFamily.header}`,
		bold: `700 16px/150% ${fontFamily.header}`,
	},
	medium: {
		light: `300 14px/143% ${fontFamily.base}`,
		base: `400 14px/143% ${fontFamily.base}`,
		medium: `500 14px/143% ${fontFamily.base}`,
		bold: `700 14px/143% ${fontFamily.base}`,
	},
	small: {
		light: `300 12px/133% ${fontFamily.base}`,
		base: `400 12px/133% ${fontFamily.base}`,
		medium: `500 12px/133% ${fontFamily.base}`,
	},
	xSmall: {
		base: `400 11px/140% ${fontFamily.base}`,
	},
	interactive: {
		button: `400 15px/140% ${fontFamily.header}`,
	},
})
